const getImagePath = (path = "/logo192.png") => `/image/${path}`;

export default getImagePath;
